/**
 * Generate a unique client ID with site handle prefix
 * Format: {siteHandle}-{uuid}
 * @param {string} siteHandle - The Craft CMS site handle
 * @returns {string} Prefixed UUID
 */
export function generateCid(siteHandle) {
  const uuid = crypto.randomUUID()
  return `${siteHandle}-${uuid}`
}

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

/**
 * Parse UTM parameters from a URL search string
 * @param {string} search - URL search string (e.g., "?utm_source=google")
 * @returns {Object|null} Object with UTM params or null if none found
 */
export function parseUtmParams(search) {
  const params = new URLSearchParams(search)
  const utmParams = {}

  for (const key of UTM_PARAMS) {
    const value = params.get(key)
    if (value) {
      utmParams[key] = value
    }
  }

  return Object.keys(utmParams).length > 0 ? utmParams : null
}

export const UTM_EXPIRY_MS = 24 * 60 * 60 * 1000 // 24 hours in milliseconds
export const CID_EXPIRY_MS = 24 * 60 * 60 * 1000 // 24 hours in milliseconds

/**
 * Check if a UTM timestamp has expired (older than 24 hours)
 * @param {number|null|undefined} timestamp - Unix timestamp in milliseconds
 * @returns {boolean} True if expired or invalid
 */
export function isUtmExpired(timestamp) {
  if (timestamp == null) {
    return true
  }
  return Date.now() - timestamp >= UTM_EXPIRY_MS
}

/**
 * Check if a CID timestamp has expired (older than 24 hours)
 * @param {number|null|undefined} timestamp - Unix timestamp in milliseconds
 * @returns {boolean} True if expired or invalid
 */
export function isCidExpired(timestamp) {
  if (timestamp == null) {
    return true
  }
  return Date.now() - timestamp >= CID_EXPIRY_MS
}
